// import { Report55Component } from "../../../components/SupportSystem/Reports/Report55Component";
import { ListReportSupportRequestComponent } from "../../../components/SupportSystem/Reports/ListReportSupportRequestComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ListReportSupportRequestContainer() {
    const titleName = "แบบขอรับการจัดสรรเงิน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <ListReportSupportRequestComponent/>
            <Footer />
        </div>   
        // 
    )
    
}